import './NotFound.css';
import {Player} from '@lottiefiles/react-lottie-player';
import notFund from "../../assets/lottie/empty-list_1.json";
import notAccess from "../../assets/lottie/92371-shield-rsos.json";
import connecting from "../../assets/lottie/90341-alligo-run.json"
import * as React from "react";


const ErrorPage = ({
                       errorType = ErrorType.CONNECTING,
                       title = "هیچ اطلاعاتی برای نمایش وجود ندارد!",
                       subTitle = "در جستجو از عبارت های متداول تر استفاده نمایید یا تعدادی از فیلتر ها را حذف نمایید."
                   }) => {
    return (
        <section style={{width: "100%", height: "100%", padding: "2rem 0"}}>
            <section className="not-found-container">
                <Player
                    style={{width:'300px',height:'200px'}}
                    loop
                    autoplay
                    className="player"
                    src={errorType}
                />

                <span className="not-found-title">
                    {title}
                </span>
                <span className="not-found-sub-title">
                    {subTitle}
                </span>
            </section>
        </section>

    )
}
export default ErrorPage

export const ErrorType = {
    "NOT_FOUND": notFund,
    "NOT_ACCESS": notAccess,
    "CONNECTING": connecting,
}